import { use } from "react";

import { WhitelabelBrandContext } from "@/providers/WhitelabelBrand";

export function useWhitelabelBrand() {
  const appBaseUrl = location.origin;
  const whitelabelBrand = use(WhitelabelBrandContext);
  return { whitelabelBrand, appBaseUrl };
}
